import { z } from "zod";

import { defaultItem, defaultUrl, transformerMdContentParam, itemSchema, urlSchema } from "../shared";
import { createId } from "@paralleldrive/cuid2";

// Schema
export const volunteerSchema = itemSchema.extend({
  organization: z.string().min(1),
  position: z.string(),
  location: z.string(),
  date: z.string(),
  summary: transformerMdContentParam,
  url: urlSchema,
});

export const minimalVolunteerSchema = volunteerSchema.omit({
  id: true,
  visible: true,
});

// Type
export type Volunteer = z.infer<typeof volunteerSchema>;
export type MinimalVolunteer = z.infer<typeof minimalVolunteerSchema>;

// Defaults
export const defaultVolunteer: Volunteer = {
  ...defaultItem,
  organization: "",
  position: "",
  location: "",
  date: "",
  summary: "",
  url: defaultUrl,
};

export const deminimalizeVolunteer = (volunteer: MinimalVolunteer): Volunteer => {
  return {
    ...defaultVolunteer,
    ...volunteer,
    id: createId(),
  };
};
